import { render, staticRenderFns } from "./ButtonsTopContainer.vue?vue&type=template&id=118fa4ae&scoped=true&"
import script from "./ButtonsTopContainer.vue?vue&type=script&lang=js&"
export * from "./ButtonsTopContainer.vue?vue&type=script&lang=js&"
import style0 from "./ButtonsTopContainer.vue?vue&type=style&index=0&id=118fa4ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "118fa4ae",
  null
  
)

export default component.exports